module.exports = require('./helpers/bundle-url').getBundleURL('9YSNU') + "search-nothing-found.524b4f56.svg";